import { Vector2 } from "../../../common/vector2.js";
import { ConveyorTutorial, ConveyorTutorialStep } from "../../../conveyor/conveyor_tutorial.js";
import { IHighlightRect } from "../../common_ui_elements/abstract_tutorial_highlight.js";
import { TutorialCursor } from "../../common_ui_elements/tutorial_cursor.js";
import { TutorialSpotlight } from "../../common_ui_elements/tutorial_spotlight.js";
import { UIElementHolder } from "../../common_ui_elements/ui_element_holder.js";
import { AbstractOverlay } from "../abstract_overlay.js";
import { OverlayId } from "../overlay_ids.js";
import { OverlayManager } from "../overlay_manager.js";

export interface ConveyorTutorialOverlayParams
{
  target: IHighlightRect;
  on_tap: () => void;
}

export class ConveyorTutorialOverlay extends AbstractOverlay
{
  private static readonly SPOTLIGHT_RADIUS_SCALE = 0.9;

  private tapped = false;

  constructor(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    width: number,
    height: number,
    params: ConveyorTutorialOverlayParams,
    overlay_id: OverlayId
  )
  {
    super( ctx, x, y, width, height, overlay_id, params, false );

    const origin = this.getAbsolutePosition();
    const target_x = params.target.x - origin.x;
    const target_y = params.target.y - origin.y;
    const target: IHighlightRect = { x: target_x, y: target_y, width: params.target.width, height: params.target.height };

    this.addChild( new TutorialSpotlight( this.ctx, this.rect.getW(), this.rect.getH(), target, ConveyorTutorialOverlay.SPOTLIGHT_RADIUS_SCALE ) );

    const hit_zone = new UIElementHolder( this.ctx, target.x, target.y, target.width, target.height );
    hit_zone.setOnClick( () => this.tap() );
    this.addChild( hit_zone );

    const tip_x = target.x + target.width / 2;
    const tip_y = target.y + target.height / 2;
    const cursor = new TutorialCursor( this.ctx );
    this.addChild( cursor );
    cursor.pointAt( new Vector2( tip_x, tip_y ) );
  }

  private get tutorial(): ConveyorTutorialOverlayParams
  {
    return this.params as ConveyorTutorialOverlayParams;
  }

  private tap(): void
  {
    if ( this.tapped )
      return;

    this.tapped = true;
    OverlayManager.closeOverlay();
    this.tutorial.on_tap();
  }

  public override drawsOwnBackground(): boolean
  {
    return true;
  }

  public override onOverlayWillClose(): void
  {
    if ( !this.tapped && ConveyorTutorial.getStep() === ConveyorTutorialStep.Widget )
      ConveyorTutorial.setStep( ConveyorTutorialStep.None );
  }

  public render(): void
  {
    if ( !this.shouldBeRendered() )
      return;

    this.startRender();
    this.finishRender();
  }

  public name(): string
  {
    return "ConveyorTutorialOverlay";
  }
}
